import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-duplicar-campana',
  templateUrl: './duplicar-campana.component.html',
  styleUrls: ['./duplicar-campana.component.scss']
})
export class DuplicarCampanaComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<DuplicarCampanaComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private gateway: GatewayService, private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar) { }

  mensaje: any = `¿Seguro que desea `;

  grupoVal = new FormGroup({
    COMENTARIO: new FormControl('', Validators.compose([
      Validators.required
    ]))
  });

  ngOnInit() {
    let datos: any = this.data;
    this.mensaje += "duplicar la campaña" + (datos.nombre ? ' "' + datos.nombre + '"' : '') + "?";
  }

  close() {
    this.dialogRef.close({ resp: false });
  }

  ejecutar() {
    let datos: any = this.data;
    this.spinner.show();

    this.gateway.get('duplicarcampana', { IDCAMPANA: datos.idcampana, NUEVO_NOMBRE_CAMPANA: this.grupoVal.controls.COMENTARIO.value }).then(
      (data: any) => {
        if (data.idcampana == 0) {
          this.snackbar.open('Ocurrio un error al duplicar la campaña. Intentelo más tarde.', 'Cerrar', { duration: 3000, });
          this.spinner.hide();
          this.dialogRef.close(true);
        } else if (data.idcampana == -1) {
          this.snackbar.open(`Ya existe una campaña con el nombre ${this.grupoVal.controls.COMENTARIO.value}.`, 'Cerrar', { duration: 3000, });
          this.spinner.hide();
        }else{
          this.snackbar.open('La campaña se ha duplicado correctamente.', 'Cerrar', { duration: 3000, });
          this.spinner.hide();
          this.dialogRef.close(true);
        }
      }
    );
  }

}
